import React from 'react'
import { useLoginFlow } from '@ztechapps/common.hook'
import { routesDef } from '../../../config/routes'
import { CenterScreen, LoadingContent } from '@ztechapps/webui.util'
import { useDeepCompareEffect } from '@ztechapps/common.hook'

export const Page = () => {
  const { redirect, accessToken, authPayload, redirect_url } = useLoginFlow()

  useDeepCompareEffect(() => {
    //if not access token just exit
    if (!accessToken) return

    //navigate to proper if already signIn
    //should navigate back to the last url that was submitted
    //do force window navigation to refresh the page
    const updateNeeded = authPayload?.updateNeeded

    if (updateNeeded) {
      //redirect to the form registration
      const url = `${routesDef.UpdateUserRegistration.path}?${new URLSearchParams(authPayload).toString()}`
      return redirect(url)
    } else {
      //if there is a redirect URL, go there
      if (redirect_url) {
        return redirect(redirect_url)
      }

      //if it still can go here, then just redirect to the default path is which is
      return redirect()
    }
  }, [authPayload])

  return (
    <CenterScreen>
      <LoadingContent message="Authenticating....." />
    </CenterScreen>
  )
}
